import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { reqSearchCrispr, reqCrisprRefGenome, reqCrisprChr } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchCrispr extends React.Component {
    state = {
        // form 表单状态
        ref_genome: '',
        ref_genome_options: '',
	strand: '',
        geneid: '',
        loc_chr: '',
        chr_options: '',
        loc_start: '',
        loc_end: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        const { ref_genome, strand, geneid, loc_chr, loc_start, loc_end } = values
        
        this.setState({
            disabled: true,
            loading: true,
	    searchResult: '',
        })

        const param = {
	    search_type: 'search_crispr',
            ref: ref_genome,
	    strand: strand,
            geneid: geneid,
            chr__exact: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            page: 1
        }
        const searchResult = await reqSearchCrispr(param)
        let table_title = ''
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                ref_genome: ref_genome,
		strand: strand,
                geneid: geneid,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    onRefGenomeChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            loc_chr: '',
            geneid: '',
        })
        
        let chr_options = []
        const result = await reqCrisprChr(val)
        if (result.code === 0) {
            chr_options = result.data.map((item) => {
                return <Option value={item['chr']} key={item['chr']}>{item['chr']}</Option>
            })
        }

        this.setState({
            chr_options: chr_options,
            geneid: ''
        })
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { ref_genome, strand, geneid, loc_chr, loc_start, loc_end } = this.state
        const { current } = pagination
	this.setState({
	    searchResult: '',
            pagination: {
                current: current,
		pageSize: 10,
                total: '',
                showSizeChanger: false,
                showQuickJumper: true
            }
      	})
        const param = {
	    search_type: 'search_crispr',
            ref: ref_genome,
	    strand: strand,
            geneid: geneid,
            chr__exact: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            page: current
        }
        const searchResult = await reqSearchCrispr(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            ref_genome_options: [],
            chr_options: []
        })
    }

    async componentDidMount() {
        let ref_genome_options = []
        const result = await reqCrisprRefGenome()
        if (result.code === 0) {
            ref_genome_options = result.data.map((item) => {
                return <Option value={item['ref']} key={item['ref']}>{item['ref']}</Option>
            })
        } else {
            message.error('Request failed. ' + result.message)
        }

        this.setState({
            ref_genome_options: ref_genome_options
        })
    }

    render() {
        const { ref_genome_options, chr_options, disabled, title, loading, has_data, searchResult, pagination } = this.state
        
        const layout = {
            labelCol: { span: 2 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 2, span: 12 },
        }

        const columns = [
            {
                title: 'RefGenome',
                dataIndex: 'ref',
                width: 100,
		        fixed: 'left',
            },
            {
                title: 'Gene ID',
                dataIndex: 'geneid',
                width: 200,
		        fixed: 'left',
            },
            {
                title: 'Chr',
                dataIndex: 'chr',
                width: 60,
            },
            {
                title: 'Strand',
                dataIndex: 'strand',
                width: 50,
            },
            {
                title: 'Position',
                dataIndex: 'posi',
                width: 100,
            },
            
            {
                title: 'Crispr Seq',
                dataIndex: 'crispr_seq',
		        ellipsis: true,
            },
            {
                title: 'Score',
                dataIndex: 'crispr_score',
                width: 100,
            },
            {
                title: 'OffTargetGeneID',
                dataIndex: 'off_target_geneid',
                width: 200,
            },
            {
                title: 'OffTarget_Chr:StrPosi',
                dataIndex: 'off_target_chr_str_posi',
                width: 200,
            },
            {
                title: 'Mismatch',
                dataIndex: 'mismatch',
                width: 100,
            },
            {
                title: 'Exon',
                dataIndex: 'exon',
                width: 250,
            },
            {
                title: 'Detailed_Posi',
                dataIndex: 'detailed_posi',
                width: 250,
            },
            {
                title: 'OffTarget_Score',
                dataIndex: 'off_target_score',
                width: 100,
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'operation',
                width: 160,
                fixed: 'right',
                render: (item) => {
                    let jbrowse_link = ''
			console.log(item.ref)
                    if (item.ref == 'SL5.0') {
                        jbrowse_link = `/tool/jbrowse/?loc=${item.chr}%3A${item.posi-50}..${item.posi+50}&tracks=DNA%2CGene%20annotation%2CRepeat%2CCrispr&highlight=`
                    } else {
                        jbrowse_link = `/tool/jbrowse/index.html?data=${item.ref}&loc=${item.chr}%3A${item.posi-50}..${item.posi+50}&tracks=DNA%2CGene%20annotation%2CRepeat%2CCrispr&highlight=`
                    }

                    return (<Link to={jbrowse_link} target="_blank"><Button type="primary" size="small" className="jbrowse-action">Jbrowse Visualizer</Button></Link>)
                }
            }
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['ref'] + '-' + v['geneid']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} labelAlign="left" name="search-crispr" ref={this.formRef} className="search-crispr-form" onFinish={this.onFinish}>
                    <Paragraph>
                        Search Crispr
                    </Paragraph>
                    <Form.Item name="ref_genome" label="Genome" rules={[{ required: true }]}>
                        <Select showArrow allowClear onChange={this.onRefGenomeChange}>
                            {ref_genome_options}
                        </Select>
                    </Form.Item>
                    <Form.Item name="strand" label="Strand" rules={[{ required: true }]} initialValue={'+'}>
                        <Select showArrow allowClear>
                            <Option value="+">+</Option>
                            <Option value="-">-</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="geneid" label="Gene ID">
                        <Input placeholder="" />
                    </Form.Item>
                    
                    <Form.Item label="Region" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr" label="chr">
					                        <Select showArrow allowClear>
			                                    {chr_options}
                        		            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and" 
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} scroll={{ x: 1300 }} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearchCrispr
